import { updatesData } from '@/mocks/homeData';

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新爆料
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            7×24小时全天候更新，热点事件发生30分钟内必有报道
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-8 top-0 bottom-0 w-0.5 bg-background-200"></div>
          <div className="space-y-6">
            {updatesData.map((item) => (
              <div key={item.id} className="relative pl-10 md:pl-16">
                <div className={`absolute left-2 md:left-6 top-1.5 w-4 h-4 rounded-full border-2 ${
                  item.hot
                    ? 'bg-primary-500 border-primary-500'
                    : 'bg-background-50 border-background-300'
                }`}></div>
                <div className="bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5 hover:border-primary-200/50 transition-colors cursor-pointer">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className={`px-2 py-0.5 rounded text-xs font-medium ${
                      item.tag === '独家'
                        ? 'bg-accent-100 text-accent-700'
                        : item.tag === '热门'
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                    {item.hot && (
                      <span className="text-xs text-primary-500 flex items-center gap-0.5">
                        <i className="ri-fire-line"></i> 热门
                      </span>
                    )}
                  </div>
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}